var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "search-add-from-library-modal"
    }
  }, [!_vm.showModal ? [_vm.enableBioMaterialTypeSelect ? _c('a', {
    attrs: {
      "href": "#",
      "id": "add-bio-materials-trigger"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.displayModal.apply(null, arguments);
      }
    }
  }, [_vm._v("Add biological material to " + _vm._s(_vm.groupTitle))]) : _c('a', {
    attrs: {
      "href": "#",
      "id": _vm.linkId
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.displayModal.apply(null, arguments);
      }
    }
  }, [_vm._v("Add " + _vm._s(_vm.materialTypeLabel))])] : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "searchAddModal",
    attrs: {
      "scrollable": "",
      "centered": "",
      "cancel-disabled": "",
      "ok-disabled": "",
      "no-stacking": "",
      "hide-footer": "",
      "hide-header": "",
      "size": _vm.modalSize,
      "id": _vm.modalId,
      "data-test": 'modal ' + _vm.getModalTitle,
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "no-enforce-focus": ""
    }
  }, [_vm.showAssociateMaterials ? _c('div', [_c('VHeader', {
    attrs: {
      "modal-button": true
    },
    on: {
      "close-modal": _vm.closeModal
    },
    scopedSlots: _vm._u([{
      key: "modal-title",
      fn: function () {
        return [_vm._v("Biological Materials Associated with Research Project")];
      },
      proxy: true
    }], null, false, 1799029978)
  }), _vm._v(" "), _c('BioProjectMaterials', {
    attrs: {
      "group-nid": _vm.groupNid
    },
    on: {
      "close-modal": _vm.closeModal
    }
  })], 1) : !_vm.materialTypeToAdd && _vm.enableBioMaterialTypeSelect ? _c('BioMaterialTypeSelect', {
    attrs: {
      "bio-material-bundles": _vm.bioMaterialBundles
    },
    on: {
      "material-type-selected": _vm.setMaterialTypeToAdd,
      "close-modal": _vm.closeModal
    }
  }) : _c('SearchAddFromLibraryParent', {
    attrs: {
      "material-type-label": _vm.materialTypeLabel || _vm.materialTypeToAddLabel,
      "group-nid": _vm.groupNid,
      "material-type": _vm.materialType || _vm.materialTypeToAdd
    },
    on: {
      "cancel-search-add": _vm.closeModal,
      "parent-status": _vm.handleEmitParentStatus
    }
  })], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }